/**
 * UsersIcon — Two people: the members of the organization. Hugeicons user-multiple-02 (MIT).
 */

import svg from './svg/users.svg?raw';
import { makeSvgIcon } from './svgIcon';

export const UsersIcon = makeSvgIcon('users', svg);
